import { createUseStyles } from "react-jss";
import { colors } from "../../constants/colors";

const styles = createUseStyles((theme) => ({
  general: {
    position: 'relative',
    display: 'flex',
    borderRadius: '8px',
    textAlign: 'center',
    // width: "fit-content",
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '20px',
    padding: '10px 16px',
    cursor: 'pointer',
    userSelect: 'none',
  },
  primary: {
    'extend': 'general',
    'color': theme.buttons.primary.color,
    'backgroundColor': theme.buttons.primary.backgroundColor,
    'border': theme.buttons.primary.border,
    '&:focus': {
      border: theme.buttons.primary.border,
      backgroundColor: theme.buttons.primary.backgroundColor,
      color: theme.buttons.primary.color,
    },
    '&:hover': {
      boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)',
      border: theme.buttons.primary.hover.border,
      backgroundColor: theme.buttons.primary.hover.backgroundColor,
      color: theme.buttons.primary.hover.color,
      transitionDuration: '200ms',
    },
    '&:focus-visible': {
      border: theme.buttons.primary.border,
      outlineOffset: '2px',
    },
    '& path': {
      stroke: theme.buttons.primary.color,
    },
  },
  secondary: {
    'extend': 'general',
    'color': theme.buttons.secondary.color,
    'backgroundColor': theme.buttons.secondary.backgroundColor,
    'border': theme.buttons.secondary.border,
    '&:focus': {
      boxShadow: `0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px ${colors.lightBlue}`,
      color: theme.buttons.secondary.hover.color,
      backgroundColor: theme.buttons.secondary.hover.backgroundColor,
      border: theme.buttons.secondary.border,
    },
    '&:hover': {
      boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)',
      color: theme.buttons.secondary.hover.color,
      backgroundColor: theme.buttons.secondary.hover.backgroundColor,
      transitionDuration: '200ms',
    },
  },
  default: {
    'extend': 'general',
    'color': theme.buttons.default.color,
    'backgroundColor': theme.buttons.default.backgroundColor,
    'border': theme.buttons.default.border,
    '&:focus': {
      border: theme.buttons.default.border,
      backgroundColor: colors.white,
      color: colors.grey,
    },
    '&:hover': {
      boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)',
      border: theme.buttons.default.border,
      backgroundColor: theme.buttons.default.hover.backgroundColor,
      color: theme.buttons.default.hover.color,
      transitionDuration: '200ms',
    },
  },
  danger: {
    'extend': 'general',
    'color': theme.buttons.danger.color,
    'backgroundColor': theme.buttons.danger.backgroundColor,
    'border': theme.buttons.danger.border,
    '&:focus': {
      border: `1px solid ${colors.brightRed}`,
      backgroundColor: colors.brightRed,
      color: colors.white,
    },
    '&:hover': {
      boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)',
      border: `1px solid ${colors.darkRed}`,
      backgroundColor: colors.darkRed,
      color: colors.white,
      transitionDuration: '200ms',
    },
  },
  deleteLink: {
    color: colors.darkRed,
    cursor: 'pointer',
  },
  defaultLink: {
    color: theme.buttons.defaultLink.color,
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    userSelect: 'none',
    width: 'fit-content',
  },
  txtHidden: {
    visibility: 'hidden',
  },
  disabled: {
    'extend': 'general',
    'color': theme.buttons.disabled.color,
    'pointerEvents': 'none',
    'backgroundColor': theme.buttons.disabled.backgroundColor,
    'border': theme.buttons.disabled.border,
    'cursor': 'not-allowed',
    '&:focus': {
      border: theme.buttons.disabled.border,
      backgroundColor: theme.buttons.disabled.backgroundColor,
      color: theme.buttons.disabled.color,
    },
    '& path': {
      stroke: theme.buttons.disabledIcon.color,
    },
  },
  defaultDisabled: {
    pointerEvents: 'none',
    backgroundColor: colors.white,
    color: colors.darkGrey,
  },
  icon: {
    marginRight: '5px',
  },
  iconEnd: {
    marginLeft: '5px',
  },
  spinnerButton: {
    top: '50%',
    marginTop: '-10px',
  },
}));

export default styles;
